import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import DarkModeToggle from '../DarkModeToggle';
import { useAuthStore } from '../../stores/authStore';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const { isAuthenticated } = useAuthStore();

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-2.5 group">
              <div className="w-8 h-8 bg-gradient-to-br from-brand-500 to-brand-400 rounded-lg flex items-center justify-center shadow-sm shadow-brand-500/25 group-hover:shadow-brand-500/40 transition-all group-hover:scale-105">
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="10" cy="9" r="4.7" fill="white"/>
                  <circle cx="10" cy="9" r="2.4" fill="#FBBF24"/>
                  <rect x="12.4" y="11.6" width="2.4" height="4.4" rx="1.1" transform="rotate(-30 13.6 13.8)" fill="white"/>
                  <rect x="3" y="16" width="18" height="2.8" rx="1.4" fill="white"/>
                </svg>
              </div>
              <span className="text-xl font-bold">
                <span className="text-slate-900 dark:text-white">Link</span>
                <span className="text-brand-500">Diry</span>
              </span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#features"
              className="text-gray-700 dark:text-gray-300 hover:text-brand-500 dark:hover:text-brand-400"
            >
              Features
            </a>
            <a
              href="#pricing"
              className="text-gray-700 dark:text-gray-300 hover:text-brand-500 dark:hover:text-brand-400"
            >
              Pricing
            </a>
            <Link
              to="/docs"
              className="text-gray-700 dark:text-gray-300 hover:text-brand-500 dark:hover:text-brand-400"
            >
              API Docs
            </Link>
            <DarkModeToggle />
            {isAuthenticated ? (
              <Link
                to="/dashboard"
                className="bg-brand-500 text-white px-6 py-2 rounded-lg hover:bg-brand-600 transition-colors"
              >
                Dashboard
              </Link>
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-gray-700 dark:text-gray-300 hover:text-brand-500 dark:hover:text-brand-400"
                >
                  Sign In
                </Link>
                <Link
                  to="/register"
                  className="bg-brand-500 text-white px-6 py-2 rounded-lg hover:bg-brand-600 transition-colors"
                >
                  Get Started
                </Link>
              </>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-4">
            <DarkModeToggle />
            <button
              onClick={toggleMenu}
              className="text-gray-700 dark:text-gray-300 hover:text-brand-500 dark:hover:text-brand-400"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800">
            <a
              href="#features"
              className="block px-3 py-2 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
              onClick={toggleMenu}
            >
              Features
            </a>
            <a
              href="#pricing"
              className="block px-3 py-2 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
              onClick={toggleMenu}
            >
              Pricing
            </a>
            {isAuthenticated ? (
              <Link
                to="/dashboard"
                className="block px-3 py-2 rounded-md bg-brand-500 text-white hover:bg-brand-600"
                onClick={toggleMenu}
              >
                Dashboard
              </Link>
            ) : (
              <>
                <Link
                  to="/login"
                  className="block px-3 py-2 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
                  onClick={toggleMenu}
                >
                  Sign In
                </Link>
                <Link
                  to="/register"
                  className="block px-3 py-2 rounded-md bg-brand-500 text-white hover:bg-brand-600"
                  onClick={toggleMenu}
                >
                  Get Started
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
